import './const.js';
import { DEFAULTS } from './defaults.js';
import { RicosPluginToolbarNames } from 'ricos-types';
import { getAddButtons } from './getAddButtons.js';
import { getToolbarButtons } from './getToolbarButtons.js';
import { tiptapExtensions } from './tiptap/tiptap.js';
import { DIVIDER_TYPE } from './types.js';
import 'wix-rich-content-common';
import 'ricos-schema';
import 'ricos-schema/dist/statics/divider.defaults.json';
import 'wix-rich-content-editor-common';
import './icons/InsertPluginIcon.js';
import 'react';
import 'ricos-content';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-toolbars-ui';
import './toolbar/buttons/DividerAlignmentButton.js';
import 'ricos-context';
import './toolbar/buttons/dividerButtonsData.js';
import './icons/SingleLineStyle.js';
import './icons/DoubleLineStyle.js';
import './icons/DashedLineStyle.js';
import './icons/DottedLineStyle.js';
import './toolbar/buttons/DividerSizeButton.js';
import './toolbar/buttons/DividerStyleButton.js';
import './toolbar/modals/DividerSizePanel.js';
import './toolbar/modals/LineStylePanel.js';
import './style-inject.es-746bb8ed.js';
import './tiptap/component.js';
import './viewer/divider-viewer.js';
import 'classnames';
import './withSafariSvgCaretFixer-04d64192.js';
import './components/divider-line.js';
import 'prop-types';
import './dataHooks.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginDivider = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULTS.config), config);
  return {
    config: pluginConfig,
    type: DIVIDER_TYPE,
    tiptapExtensions,
    getAddButtons: (config2, services) => getAddButtons(),
    toolbar: {
      names: [RicosPluginToolbarNames.DIVIDER],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    }
  };
};

export { pluginDivider };
//# sourceMappingURL=editor.js.map
